<template>
  <div class="search-top">
    <div class="wrap">
      <ul class="ch-search-tag02">
        <li
          v-for="(tag, index) in tagDataList"
          :key="index"
        >
          <button
            @click="$emit('click-fn', tag)"
            :class="{'search-tag02-on' : isSelected(tag)}"
          >
            #{{ tag.text }}
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchTopTagGroup',
  props: {
    tagDataList: {
      type: Array,
      default: null
    }
  },
  methods: {
    isSelected (tag) {
      return tag?.selected === 'y'
    }
  }
}
</script>
